import { typeAPI } from "./../../services/TypeAPI"
import { TYPE_FETCH, TYPE_SUCCESS, TYPE_FAILURE, TYPE_FETCH_ADMIN, TYPE_SUCCESS_ADMIN, TYPE_FAILURE_ADMIN, TYPE_UPDATEALL_ADMIN } from "./../types"

export const fetchType = () => {
    return async dispatch => {
        dispatch({ type: TYPE_FETCH, payload: null, error: null })
        typeAPI.getType()
            .then((response) => {
                if (response.status == 200) {
                    setTimeout(() => {
                        dispatch({ type: TYPE_SUCCESS, payload: response.message, error: null })
                    }, 500);
                }
                else {
                    dispatch({ type: TYPE_FAILURE, payload: [], error: response.message })
                }
            })
            .catch(error => {
                dispatch({ type: TYPE_FAILURE, payload: [], error: error.message })
            })
    };
};

export const fetchTypeAdmin = () => {
    return async dispatch => {
        dispatch({ type: TYPE_FETCH_ADMIN, payload: null, error: null })
        typeAPI.getTypeAdmin()
            .then((response) => {
                if (response.status == 200) {
                    setTimeout(() => {
                        dispatch({ type: TYPE_SUCCESS_ADMIN, payload: response.message, error: null })
                    }, 500);
                }
                else {
                    dispatch({ type: TYPE_FAILURE_ADMIN, payload: [], error: response.message })
                }
            })
            .catch(error => {
                dispatch({ type: TYPE_FAILURE_ADMIN, payload: [], error: error.message })
            })
    };
};

export const updateStatusTypeAdmin = ({ _id, status }) => {
    return async (dispatch, getState) => {
        dispatch({ type: TYPE_FETCH_ADMIN, payload: null, error: null })
        let { type: DataTypeAdmin } = getState()
        typeAPI.updateStatus({ _id, status })
            .then((response) => {
                if (response.status == 200) {
                    let newData = [...DataTypeAdmin.DataTypeAdmin]
                    let findIndex = newData.findIndex((res) => res._id == response.message._id)
                    if (findIndex >= 0) {
                        let findIndex = newData.findIndex((res) => res._id == response.message._id)
                        newData[findIndex] = response.message
                    }
                    else {
                        newData = [...DataTypeAdmin, response.message]
                    }
                    setTimeout(() => {
                        dispatch({ type: TYPE_UPDATEALL_ADMIN, payload: newData, error: null })
                    }, 500);
                }
                else {
                    dispatch({ type: TYPE_FAILURE_ADMIN, payload: [], error: response.message })
                }
            })
            .catch(error => {
                dispatch({ type: TYPE_FAILURE_ADMIN, payload: [], error: error.message })
            })
    };
}


export const addFolderInType = ({ dir, name }) => {
    return async (dispatch, getState) => {
        let { type: DataTypeAdmin } = getState()
        let newData = [...DataTypeAdmin.DataTypeAdmin]
        let findIndex = newData.findIndex((res) => res.dir == dir)
        if (findIndex >= 0) {
            if (Array.isArray(newData[findIndex].path)) {
                newData[findIndex].path.push({ name, path: [] })
            }
            setTimeout(() => {
                dispatch({ type: TYPE_UPDATEALL_ADMIN, payload: newData, error: null })
            }, 500);
        }
    };
};

export const addFileInType = ({ newFile, dir, path }) => {
    return async (dispatch, getState) => {
        let { type: DataTypeAdmin } = getState()
        let newData = [...DataTypeAdmin.DataTypeAdmin]
        let findIndex = newData.findIndex((res) => res.dir == dir)
        if (findIndex >= 0) {
            if (Array.isArray(newData[findIndex].path)) {
                let indexPath = newData[findIndex].path.findIndex((res) => res.name == path)
                if (indexPath <= 0) {
                    if (Array.isArray(newData[findIndex].path[indexPath].list)) {
                        let newdata = newData[findIndex].path[indexPath].list.concat(newFile)
                        newdata = newdata.reduce((prev, curr) => {
                            let same = prev.find((rex) => rex == curr)
                            if (!same) {
                                prev.push(curr)
                            }
                            return prev
                        }, [])
                        newData[findIndex].path[indexPath].list = newdata
                    }
                }
            }
            setTimeout(() => {
                dispatch({ type: TYPE_UPDATEALL_ADMIN, payload: newData, error: null })
            }, 500);
        }
    };
};